import { chakra } from '@chakra-ui/system';
import { Parallax as RSParallax } from 'react-scroll-parallax';

// eslint-disable-next-line import/prefer-default-export
export const Parallax = chakra(RSParallax);
